export const timeConf={
  seconds:{
    "1":{
      text:"每一秒钟",
    },
    "2":{
      text:"秒",
      values:[5,3]
    },
    "3":{
      text:"秒",
      values:[1,3]
    },
    "4":{
      text:"秒数",
      values:[]
    }
  },
  minutes:{
    "1":{
      text:"每一分钟"
    },
    "2":{
      text:"分",
      values:[5,3]
    },
    "3":{
      text:"分",
      values:[1,3]
    },
    "4":{
      text:"分钟数",
      values:[]
    }
  },
  hours:{
    "1":{
      text:"每一小时"
    },
    "2":{
      text:"小时",
      values:[5,3]
    },
    "3":{
      text:"小时",
      values:[1,3]
    },
    "4":{
      text:"小时数",
      values:[]
    }
  },
  month:{
    "1":{
      text:"每一月"
    },
    "2":{
      text:"月",
      values:[5,3]
    },
    "3":{
      text:"月",
      values:[1,3]
    },
    "4":{
      text:"月份",
      values:[]
    }
  }
}